import { useDispatch } from 'react-redux';
import { TDispatch } from '../types/referral/store';

export const useReferralAppDispatch: () => TDispatch = useDispatch;
